 
import { actionTypeManageContact } from 'consts/data';
import produce from 'immer';
import { toString } from 'lodash';

export const baseContactReducer = () => {
  return {
    isFetching: false,
    isFiltering: false,
    isFetchedManage: false,
    progressId: undefined,
    listContactScrubbing: [],
    listAllRunningLandline: [],
    headerField: [],

    contacts: [],
    total: 0,
    groupId: null,
    infoContact: {},
    isFetched: false,
    errorContact: null,

    //* base check import
    previewLine: [],

    //* base import contact
    startImporting: false,
    isRequestImporting: false,
    processIdImport: undefined,
    itemRunningImport: {},

    //* base upload contact
    isUploading: false,
    errorUploadFile: null,

    //* base manage contact
    isFetchingManage: false,
    isLast: false,
    optionContacts: [],
    manageContacts: [],

    //* base data consuming
    dataConsuming: {
      isConsuming: false,
      consumingAvailable: false,
      userId: '',
      groupId: '',
      processed: '',
      total: '',
      created: '',
    },

    //* base data refreshing
    dataRefreshing: {
      isRefreshingCalling: false,
      refreshingAvailable: false,
      userId: '',
      groupId: '',
      processed: '',
      total: '',
      created: '',
    },
  };
};

//! set lead callback link
export const fetchSetLeadCallbackLink = (actions, state) => {
  return produce(state, (draft) => {
    draft.infoContact.metadata.leadCallback = actions.leadCallback;
  });
};

//! lead filter
export const fetchLeadFilter = (actions, state) => {
  return produce(state, (draft) => {});
};

export const fetchLeadFilterSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.infoContact.metadata.leadFilter = actions.nextLeadFilter;
  });
};

export const fetchLeadFilterFailed = (actions, state) => {
  return produce(state, (draft) => {});
};

//! data consuming
export const fetchDataConsuming = (actions, state) => {
  return produce(state, () => {
    // draft.dataConsuming.isConsuming = true;
  });
};

export const fetchDataConsumingSuccess = (actions, state) => {
  const { consumingAvailable, created, groupId, processed, total, userId } = actions;
  return produce(state, (draft) => {
    draft.dataConsuming.consumingAvailable = consumingAvailable;
    if (consumingAvailable) {
      draft.dataConsuming.created = created;
      draft.dataConsuming.groupId = groupId;
      draft.dataConsuming.processed = processed;
      draft.dataConsuming.total = total;
      draft.dataConsuming.userId = userId;
    } else {
      draft.dataConsuming = baseContactReducer().dataConsuming;
    }
  });
};

export const fetchDataConsumingFailed = (actions, state) => {
  const { consumingAvailable } = actions;
  return produce(state, (draft) => {
    draft.dataConsuming.consumingAvailable = consumingAvailable;
    draft.dataConsuming.created = '';
    draft.dataConsuming.groupId = '';
    draft.dataConsuming.processed = '';
    draft.dataConsuming.total = '';
    draft.dataConsuming.userId = '';
  });
};

//! start consuming
export const fetchStartDataConsuming = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataConsuming.isConsuming = true;
  });
};

export const fetchStartDataConsumingSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataConsuming.isConsuming = false;
  });
};

export const fetchStartDataConsumingFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataConsuming.isConsuming = false;
  });
};

//! data consuming
export const fetchDataRefreshing = (actions, state) => {
  return produce(state, () => {
    // draft.dataRefreshing.isRefreshing = true;
  });
};

export const fetchDataRefreshingSuccess = (actions, state) => {
  const { refreshingAvailable, created, groupId, processed, total, userId } = actions;
  return produce(state, (draft) => {
    draft.dataRefreshing.refreshingAvailable = refreshingAvailable;
    if (refreshingAvailable) {
      draft.dataRefreshing.created = created;
      draft.dataRefreshing.groupId = groupId;
      draft.dataRefreshing.processed = processed;
      draft.dataRefreshing.total = total;
      draft.dataRefreshing.userId = userId;
    } else {
      draft.dataRefreshing = baseContactReducer().dataRefreshing;
    }
  });
};

export const fetchDataRefreshingFailed = (actions, state) => {
  const { refreshingAvailable } = actions;
  return produce(state, (draft) => {
    draft.dataRefreshing.refreshingAvailable = refreshingAvailable;
    draft.dataRefreshing.created = '';
    draft.dataRefreshing.groupId = '';
    draft.dataRefreshing.processed = '';
    draft.dataRefreshing.total = '';
    draft.dataRefreshing.userId = '';
  });
};

//! start refreshing
export const fetchStartDataRefreshing = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataRefreshing.isRefreshingCalling = true;
  });
};

export const fetchStartDataRefreshingSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataRefreshing.isRefreshingCalling = false;
  });
};

export const fetchStartDataRefreshingFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataRefreshing.isRefreshingCalling = false;
  });
};

//! contact api servlet
export const fetchContactServlet = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = true;
  });
};

export const fetchContactServletSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.contacts = actions.contacts;
    draft.total = actions.total;
    draft.groupId = actions.groupId;
    draft.infoContact = actions.infoContact;
    draft.isFetching = false;
    draft.isFetched = true;
    draft.isFiltering = false;
    draft.errorContact = null;
  });
};

export const fetchContactServletFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorContact = actions.error;
    draft.isFetching = false;
    draft.isFetched = true;
  });
};

//! check status import
export const fetchCheckImport = (actions, state) => {
  return produce(state, () => {});
};

export const fetchCheckImportSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.itemRunningImport =
      draft.processIdImport != undefined ? actions.data || draft.itemRunningImport : {};
  });
};

export const fetchCheckImportFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isImporting = false;
  });
};

export const fetchCancelImportSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.processIdImport = undefined;
    draft.itemRunningImport = {};
    draft.isImporting = false;
    draft.previewLine = [];
  });
};

//! import contact
export const fetchImportStorage = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRequestImporting = true;
  });
};

export const fetchImportStorageSuccess = (actions, state) => {
  const { processIdImport, itemRunningImport, startImporting } = actions;
  return produce(state, (draft) => {
    draft.isImporting = true;
    draft.isRequestImporting = false;
    draft.processIdImport = processIdImport;
    draft.itemRunningImport = itemRunningImport;
    draft.startImporting = startImporting;
  });
};

export const fetchImportStorageFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRequestImporting = false;
    draft.processIdImport = undefined;
    draft.itemRunningImport = {};
  });
};

//! upload contact
export const fetchUploadContact = (actions, state) => {
  return produce(state, (draft) => {
    draft.isUploading = true;
  });
};

export const fetchUploadContactSuccess = (actions, state) => {
  const { data } = actions;
  return produce(state, (draft) => {
    draft.isUploading = false;
    draft.errorUploadFile = data;
  });
};

export const fetchUploadContactFailed = (actions, state) => {
  const { error } = actions;
  return produce(state, (draft) => {
    draft.isUploading = false;
    draft.errorUploadFile = error;
  });
};

//! remove contact group
export const removeContactGroupSuccess = (actions, state) => {
  const { groupSeleted } = actions;
  return produce(state, (draft) => {
    draft.manageContacts = draft.manageContacts.filter((el) => !groupSeleted.includes(el.id));
  });
};

//! change name contact
export const changeNameSuccess = (actions, state) => {
  const { groupId, name } = actions;
  return produce(state, (draft) => {
    const groupFounded = draft.manageContacts.find((el) => toString(groupId) === toString(el.id));
    if (groupFounded) {
      groupFounded.name = name;
    }
  });
};
//! Load more manage contact
export const loadMoreContactSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLast = actions.isLast;
    draft.manageContacts = [...draft.manageContacts, ...actions.data];
  });
};

export const loadMoreContactFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorLoadMoreContact = actions.error;
  });
};

//! Get manage contact
export const changeTypeContact = (actions, state) => {
  //* Fix bug when change contact tab, old item call API get total
  return produce(state, (draft) => {
    draft.manageContacts = [];
  });
};

export const fetchManageContact = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingManage = true;
  });
};

export const fetchManageContactSuccess = (actions, state) => {
  const { action, isLast } = actions;

  return produce(state, (draft) => {
    draft.isFetchingManage = false;
    draft.isLast = isLast;
    if (action === actionTypeManageContact.searchDeviceGroups) {
      draft.optionContacts = actions.data;
    } else {
      draft.manageContacts = actions.data;
    }
  });
};

//! Set did group in responder
export const fetchSearchContact = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = true;
  });
};

export const fetchSearchContactSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.contacts = actions.payload.contacts;
    draft.total = actions.payload.total;
    draft.isFetching = false;
  });
};

export const fetchSearchContactFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = false;
  });
};

//! Remove group
export const fetchRemoveGroupSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.manageContacts = draft.manageContacts.filter(
      (el) => !(actions?.groupSeleted || []).includes(el.id)
    );
  });
};

//! Remove contact
export const fetchRemoveContact = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRemoving = true;
  });
};

export const fetchRemoveContactSuccess = (actions, state) => {
  const { phoneSelected, isSelectAll } = actions.payload;
  const listPhoneRemoved = phoneSelected?.map((ele) => ele.phone) || [];
  return produce(state, (draft) => {
    draft.contacts = isSelectAll
      ? []
      : draft.contacts.filter((contact) => !listPhoneRemoved.includes(contact.phone));
    draft.total = isSelectAll ? 0 : draft.total - listPhoneRemoved.length;
    draft.isRemoving = false;
  });
};

export const fetchRemoveContactFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRemoving = false;
    draft.errorRemoveContact = actions.error;
  });
};

//! Remove by carrier
export const fetchRemoveContactCarrier = (actions, state) => {
  return produce(state, (draft) => {
    return draft;
  });
};

export const fetchRemoveContactCarrierSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.contacts =
      draft.contacts?.filter((contact) => !actions.carrier.includes(contact.carrier)) || [];
    draft.total = actions.total;
    draft.isRemoving = false;
  });
};

export const fetchRemoveContactCarrierFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRemoving = false;
    draft.errorRemoveContact = actions.error;
  });
};

//! Unmount
export const unmountContactDetail = (actions, state) => {
  return produce(state, () => {
    return baseContactReducer();
  });
};
